<template>
  <span>
    <div class="filter-option" v-if="hasCustomers">
      {{ customerLabel }}
      <a-select
          v-model="filter.customers"
          @change="emitFilterRequest"
          style="min-width: 120px"
          mode="multiple"
          allowClear
          :locale="locale"
          :placeholder="customerLabel"
          option-filter-prop="children"
          :filter-option="filterOption"
      >
        <a-select-option
            v-for="customer in filterOptions.customers"
            :key="customer.id"
            :value="customer.id"
        >
          {{ customer.full_name }}
        </a-select-option>
      </a-select>
    </div>
    <div class="filter-option" v-if="hasAgencies">
      {{ agencyLabel }}
      <a-select
          v-model="filter.agencies"
          @change="emitFilterRequest"
          style="min-width: 120px"
          mode="multiple"
          allowClear
          :locale="locale"
          :placeholder="agencyLabel"
          option-filter-prop="children"
          :filter-option="filterOption"
      >
        <a-select-option
            v-for="agency in filterOptions.agencies"
            :key="agency.id"
            :value="agency.id"
        >
          {{ agency.name }}
        </a-select-option>
      </a-select>
    </div>
<!-- TODO ProductLabel Filter does not yet work properly; hidden for staging-test -->
<!--    <div class="filter-option" v-if="hasProductLabels">-->
<!--      {{ productLabelLabel }}-->
<!--      <a-select-->
<!--          v-model="filter.productLabels"-->
<!--          @change="emitFilterRequest"-->
<!--          style="min-width: 120px"-->
<!--          mode="multiple"-->
<!--          allowClear-->
<!--          :locale="locale"-->
<!--          :placeholder="productLabelLabel"-->
<!--          option-filter-prop="children"-->
<!--          :filter-option="filterOption"-->
<!--      >-->
<!--        <a-select-option-->
<!--            v-for="productLabel in filterOptions.productLabels"-->
<!--            :key="productLabel.id"-->
<!--            :value="productLabel.id"-->
<!--        >-->
<!--          {{ productLabel.name }}-->
<!--        </a-select-option>-->
<!--      </a-select>-->
<!--    </div>-->
  </span>
</template>

<script>
import StaticSearchCategoryEnum from "~/enums/StaticSearchCategoryEnum";
import customerApi from '~/api/customer';
import agencyApi from '~/api/agency';
import productLabelApi from '~/api/product_label';
import locale from "ant-design-vue/lib/date-picker/locale/nl_NL";

export default {
  name: "StaticSelectionGenericFilterOptions",
  props: {
    staticSearch: {
      type: Object,
      required: true,
    },
    customerLabel: {
      type: String,
      default: 'Klant',
    },
    agencyLabel: {
      type: String,
      default: 'Maatschappij',
    },
    productLabelLabel: {
      type: String,
      default: 'Product label',
    },
    // TODO work in progress for clear filters function:
    // filter: {
    //   type: Object,
    //   default: {
    //     customers: [],
    //     agencies: [],
    //     productLabels: [],
    //   }
    // }
  },
  data() {
    return {
      locale,
      filter: {
        customers: [],
        agencies: [],
        productLabels: [],
      },
      filterOptions: {
        agencies: [],
        customers: [],
        productLabels: []
      },
    }
  },
  methods: {
    emitFilterRequest() {
      this.$emit('generic-filter-options-request', this.filter);
    },
    filterOption(input, option) {
      return (
          option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
  },
  computed: {
    canFilterByAgency() {
      // TODO update applicable models
      const applicableModels = [
        StaticSearchCategoryEnum.MORTGAGE,
        StaticSearchCategoryEnum.DAMAGE,
      ];
      return applicableModels.includes(this.staticSearch.model);
    },
    canFilterByCustomer() {
      // TODO update applicable models
      const applicableModels = [
        StaticSearchCategoryEnum.POLICY,
        StaticSearchCategoryEnum.MORTGAGE,
        StaticSearchCategoryEnum.DAMAGE,
      ];
      return applicableModels.includes(this.staticSearch.model);
    },
    canFilterByProductLabel() {
      // TODO update applicable models
      const applicableModels = [
        StaticSearchCategoryEnum.MORTGAGE,
      ];
      return applicableModels.includes(this.staticSearch.model);
    },
    hasAgencies() {
      return typeof this.filterOptions.agencies !== 'undefined' && this.filterOptions.agencies.length > 0;
    },
    hasCustomers() {
      return typeof this.filterOptions.customers !== 'undefined' && this.filterOptions.customers.length > 0;
    },
    hasProductLabels() {
      return typeof this.filterOptions.productLabels !== 'undefined' && this.filterOptions.productLabels.length > 0;
    }
  },
  mounted() {
    if (this.canFilterByCustomer) {
      customerApi.getByStaticSearchHash(this.staticSearch.key).then(response => {
        this.filterOptions.customers = response.data;
      });
    }
    if (this.canFilterByAgency) {
      agencyApi.getByStaticSearchHash(this.staticSearch.key).then(response => {
        this.filterOptions.agencies = response.data;
      });
    }
    if (this.canFilterByProductLabel) {
      productLabelApi.getByStaticSearchHash(this.staticSearch.key).then(response => {
        this.filterOptions.productLabels = response.data;
      });
    }
  }
}
</script>

<style scoped>
.filter-option {
  display: inline-block;
  margin-left: 5px;
  height: 45px
}
</style>